import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'

Vue.use(Vuex);

const state = {
    app: sessionStorage.getItem('app'),
    // 当前登录用户资料
    my: sessionStorage.getItem('my'),
    // 当前登录用户token
    token: sessionStorage.getItem('token'),
    // 分页配置
    pageSizes: [2, 10, 15, 20, 30, 50],
    // 监控字段
    logFields: [
        {name: 'pm25', text: 'PM2.5', unit: 'ug/m3'},
        {name: 'pm10', text: 'PM10', unit: 'ug/m3'},
        {name: 'tsp', text: 'TSP', unit: 'ug/m3'},
        {name: 'temperature', text: '温度', unit: '℃'},
        {name: 'humidity', text: '湿度', unit: '%'},
        {name: 'noise', text: '噪声', unit: 'dB'},
        {name: 'ws', text: '风速', unit: 'm/s'},
        {name: 'wd', text: '风向', unit: ''},
        {name: 'wp', text: '风力', unit: ''},
        {name: 'atmosphere', text: '大气压', unit: 'kpa'},
        // {name: 'noi', text: '负氧离子', unit: 'ug/m3'},
        // {name: 'so2', text: '二氧化硫', unit: 'ug/m3'},
        // {name: 'nox', text: '氮氧化合物', unit: 'ug/m3'},
        // {name: 'co', text: '一氧化碳', unit: 'ug/m3'},
        // {name: 'o3', text: '臭氧', unit: 'ug/m3'},
        // {name: 'lux', text: '光照度', unit: 'lux'},
        // {name: 'par', text: '光和有效', unit: 'lux'}
    ],
    // 塔机监控字段
    logTowerFields: [
        {name: 'wei', text: '吊重', unit: 't'},
        {name: 'scope', text: '幅度', unit: 'm'},
        {name: 'hi', text: '高度', unit: 'm'},
        {name: 'rot', text: '回转角度', unit: '°'},
        {name: 'mom', text: '额定吊重', unit: 't'},
        {name: 'momper', text: '力矩百分比', unit: '%'},
        {name: 'ws', text: '风速', unit: 'm/s'},
        {name: 'frake', text: '前倾角', unit: '°'},
        {name: 'st', text: '状态', unit: ''},
        // {name: 'noi', text: '负氧离子', unit: 'ug/m3'},
        // {name: 'so2', text: '二氧化硫', unit: 'ug/m3'},
        // {name: 'nox', text: '氮氧化合物', unit: 'ug/m3'},
        // {name: 'co', text: '一氧化碳', unit: 'ug/m3'},
        // {name: 'o3', text: '臭氧', unit: 'ug/m3'},
        // {name: 'lux', text: '光照度', unit: 'lux'},
        // {name: 'par', text: '光和有效', unit: 'lux'}
    ],
    // 升降机监控字段
    logLifterFields: [
        {name: 'weight', text: '载重', unit: 't'},
        {name: 'hi', text: '高度', unit: 'm'},
        {name: 'speed', text: '运行速度', unit: 'm/s'},
        {name: 'fdoorstat', text: '前门状态', unit: ''},
        {name: 'bdoorstat', text: '后门状态', unit: ''},
        {name: 'stat', text: '升降机状态', unit: ''},
        {name: 'face', text: '人脸识别状态', unit: ''},
        // {name: 'noi', text: '负氧离子', unit: 'ug/m3'},
        // {name: 'so2', text: '二氧化硫', unit: 'ug/m3'},
        // {name: 'nox', text: '氮氧化合物', unit: 'ug/m3'},
        // {name: 'co', text: '一氧化碳', unit: 'ug/m3'},
        // {name: 'o3', text: '臭氧', unit: 'ug/m3'},
        // {name: 'lux', text: '光照度', unit: 'lux'},
        // {name: 'par', text: '光和有效', unit: 'lux'}
    ],
    // 电表监控字段
    logDBFields: [
        {name: 'kwh', text: '总电能', unit: 'KWH'},
        {name: 'kw', text: '有功功率', unit: 'KW'},
        {name: 'av', text: 'A相电压', unit: 'V'},
        {name: 'bv', text: 'B相电压', unit: 'V'},
        {name: 'cv', text: 'C相电压', unit: 'V'},
        {name: 'aa', text: 'A相电流', unit: 'A'},
        {name: 'ba', text: 'B相电流', unit: 'A'},
        {name: 'ca', text: 'C相电流', unit: 'A'},
        {name: 'kvarh', text: '总无功电能', unit: 'Kvarh'},
        {name: 'kvar', text: '无功功率', unit: 'Kvar'},
    ],
    // 料台监控字段
    logXlptFields: [
        {name: 'wei', text: '载重', unit: 't'},
        {name: 'stat', text: '料台状态', unit: ''},
    ],
    // 高支模监控字段
    logGzmFields: [
        {name: 'wei', text: '承重', unit: 't'},
        {name: 'hor', text: '水平位移', unit: 'dm'},
        {name: 'vert', text: '垂直位移', unit: 'dm'},
        {name: 'va', text: '立杆倾角', unit: '°'},
        {name: 'ha', text: '水平倾角', unit: '°'},
        {name: 'stat', text: '安全状态', unit: ''},
    ],
    // 报警字段
    alarmFields: [
        {name: 'pm25', text: 'PM2.5', unit: 'ug/m3'},
        {name: 'pm10', text: 'PM10', unit: 'ug/m3'},
        {name: 'tsp', text: 'TSP', unit: 'ug/m3'}
    ],
    // 塔机报警字段
    alarmTowerFields: [
        {name: '全部报警', value: 0,},
        {name: '起重量报警', value: 1,},
        {name: '最大幅度限位报警', value: 3,},
        {name: '最下幅度限位报警', value: 5,},
        {name: '高度向上报警', value: 7,},
        {name: '力矩报警', value: 9,},
        {name: '防碰撞报警', value: 11,},
        {name: '风速报警', value: 15,},
        {name: '倾角报警', value: 16,},
        {name: '左限位报警', value: 17,},
        {name: '右限位报警', value: 18,},
    ],
    // 高支模报警字段
    alarmGzmFields: [
        {name: '全部报警', value: 0,},
        {name: '位移报警', value: 2,},
        {name: '角度报警', value: 6,},
        {name: '承重报警', value: 10,},
    ],
    // 当前激活设备编号
    activeProjectId: '',
    // 当前激活设备编号
    activeEquipmentId: '',
    // 当前激活塔机设备编号
    activeTowerEquipmentId: '',
    // 当前激活升降机设备编号
    activeLifterEquipmentId: '',
    // 当前激活的电表设备编号
    activeDBEquipmentId: '',
    //当前激活的高支模编号
    activeGzmEquipmentId:'',
    //当前激活的除尘控制编号
    activeCckzEquipmentId:'',
    activeProject:  sessionStorage.getItem('activeProject'),
    // 子菜单 实名
    shimingList: [
        {title: '实名', src: '../../../static/images/zhgd/shiming.png',to:'/shiming'},
        {title: '场内人员定位', src: '../../../static/images/zhgd/positioning.png',to:'/shiming/renyuandingwei'},
        {title: '非法入侵', src: '../../../static/images/zhgd/The_invasion_of.png',to:'/shiming/feifaruqin'},
        {title: '高危区域', src: '../../../static/images/zhgd/high_risk.png',to:'/shiming/gaoweiquyu'},
        {title: '安全帽实时监控', src: '../../../static/images/zhgd/safety_helmet.png',to:'/shiming/shishijiankong'},
    ],
    huanjingList: [
        {title: '环境', src: '../../../static/images/zhgd/environmen.png',to:'/huanjing'},
        {title: '洗车系统', src: '../../../static/images/zhgd/Wash.png',to:'/huanjing/xichexitong'},
        {title: '雾炮喷淋', src: '../../../static/images/zhgd/spray.png',to:'/huanjing/wupaopenlin'},
    ],
    anquanList: [
        {title: '塔机', src: '../../../static/images/zhgd/taji.png',to:'/anquan'},
        {title: '升降机', src: '../../../static/images/zhgd/shengjiangji.png',to:'/anquan/shengjiangji'},
        {title: '料台', src: '../../../static/images/zhgd/liaotai.png',to:'/anquan/liaotai'},
        {title: '养护室', src: '../../../static/images/zhgd/yanghushi.png',to:'/anquan/yanghushi'},
        {title: '高支模', src: '../../../static/images/zhgd/gaozhimo.png',to:'/anquan/gaozhimo'},
        {title: '烟感', src: '../../../static/images/zhgd/yangan.png',to:'/anquan/yangan'},
        {title: '智能电表', src: '../../../static/images/zhgd/zhinengdianbiao.png',to:'/anquan/zhinengdianbiao'},
        {title: '智能水表', src: '../../../static/images/zhgd/zhinengshuibiao.png',to:'/anquan/zhinengshuibiao'},
    ],
    fuzhuList: [
        {title: '巡检系统', src: '../../../static/images/zhgd/xunjian.png',to:'/fuzhu'},
        {title: '螺丝松紧检测系统', src: '../../../static/images/zhgd/luosisongjin.png',to:'/fuzhu/luosisongjin'},
        {title: '智能货运称重系统', src: '../../../static/images/zhgd/huoyunchengzhong.png',to:'/fuzhu/huoyunchengzhong'},
        {title: '安全广播辅助系统', src: '../../../static/images/zhgd/anquanguangbo.png',to:'/fuzhu/anquanguangbo'},
        {title: '大体积混凝土温度监控辅助系统', src: '../../../static/images/zhgd/hunningtuwendu.png',to:'/fuzhu/hunningtuwendu'},
    ],
};

const mutations = {
    updateApp: (state, data) => {
        let app = JSON.stringify(data);
        state.app = app;
        sessionStorage.setItem('app', app);
    },
    clearApp: state => {
        state.app = null;
        sessionStorage.removeItem('app');
    },
    updateMy: (state, data) => {
        let my = JSON.stringify(data);
        state.my = my;
        sessionStorage.setItem('my', my);
    },
    clearMy: (state) => {
        state.my = null;
        sessionStorage.removeItem('my');
    },
    updateToken: (state, data) => {
        state.token = data;
        sessionStorage.setItem('token', data);
    },
    clearToken: (state) => {
        state.token = null;
        sessionStorage.removeItem('token');
    },
    updateActiveEquipmentId: (state, data) => {
        state.activeEquipmentId = data;
    },
    updateActiveTowerEquipmentId: (state, data) => {
        state.activeTowerEquipmentId = data;
    },
    updateActiveLifterEquipmentId: (state, data) => {
        state.activeLifterEquipmentId = data;
    },
    updateActiveDBEquipmentId: (state, data) => {
        state.activeDBEquipmentId = data;
    },
    updateActiveGzmEquipmentId: (state, data) => {
        state.activeGzmEquipmentId = data;
    },
    updateActiveCckzEquipmentId: (state, data) => {
        state.activeCckzEquipmentId = data;
    },
    updateActiveProjectId: (state, data) => {
        state.activeProjectId = data;
    },

    updateActiveProject: (state, data) => {
        let activeProject = JSON.stringify(data);
        state.activeProject = activeProject;
        sessionStorage.setItem('activeProject', activeProject);
    },
    clearActiveProject: state => {
        state.activeProject = null;
        sessionStorage.removeItem('activeProject');
    },
};

const getters = {
    my: state => {
        return state.my ? JSON.parse(state.my) : null;
    },
    app: state => {
        return state.app ? JSON.parse(state.app) : null;
    },
    activeProject: state => {
        return state.activeProject ? JSON.parse(state.activeProject) : null;
    }
};

const actions = {};

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    modules: {}
});



// WEBPACK FOOTER //
// ./src/sotre/index.js